import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './service/auth.service';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(public authService: AuthService, public router: Router) {}

  canActivate(): boolean {
    const currentUrl = window.location.href; // Get the full current URL
    const url = new URL(currentUrl);
    const pathname = url.pathname; // Get the path (e.g., "/workflow-task")
    const queryString = url.searchParams.get('qs'); // Get the "qs" query string value

    if (!this.authService.isAuthenticated()) {
      if (pathname === '/workflow-task' && queryString === 'pendingtasks') {
        console.log('Storing workflow-task route in localStorage');
        // Store the full URL in localStorage
        debugger;
        localStorage.setItem('redirectUrl', pathname);
      }

      if (this.authService.getToken()) {
        // console.log('Login - Ahsan');
        // console.log('1 -', currentUrl);

        // Redirect to the stored URL if it exists, otherwise to the dashboard
        // const redirectUrl = localStorage.getItem('redirectUrl');
        // if (redirectUrl) {
        //   // localStorage.removeItem('redirectUrl'); // Clear the stored URL after use
        //   this.router.navigateByUrl(redirectUrl);
        // } else {
        //   this.router.navigate(['/dashboard']);
        // }
        this.router.navigate(['/dashboard']);
      } else {
        // console.log('Login - Ahsan');
        // console.log('2 -', currentUrl);
        this.router.navigate(['/login']);
      }
    }

    return this.authService.isAuthenticated();
  }


}

